import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './search-result-card.module.scss';
import ConditionalWrapRender from '../../helper/conditional-wrap-render';
import { HighlightedCard, HighlightedCardVariants } from './highlighted-card-redesign';
import { SelectedItem } from '../../../../types/aggregating';
import { Occupancy } from '../../../aggregating-by-grade/type/types';

type Props = {
  children?: ReactNode;
  galleryPreview?: ReactNode;
  highlightedText?: string;
  highlightedVariant?: HighlightedCardVariants;
  accommodationDescription?: string;
  gridLayout?: boolean;
  leadingPrice?: number;
  partnerLeadingPrice?: number;
  available?: boolean;
  gradeCode?: string;
  setSelection?: (selection: SelectedItem) => void;
  selectedGrade?: string;
  occupancyData?: Occupancy;
  availabilityLabel?: string;
};

export const SearchResultCard = ({
  children,
  galleryPreview,
  highlightedText,
  highlightedVariant,
  accommodationDescription,
  gridLayout,
  leadingPrice,
  partnerLeadingPrice,
  available,
  gradeCode,
  setSelection,
  selectedGrade,
  occupancyData,
  availabilityLabel,
}: Props) => {
  const selection = {
    selection: gradeCode || '',
    selectionName: accommodationDescription,
    price: leadingPrice,
    discountedPrice: partnerLeadingPrice,
    soldOut: !available,
    occupancy: {
      totalUnitsRemaining: occupancyData?.totalUnitsRemaining,
      totalOccupancy: occupancyData?.totalOccupancy,
      availabilityLabel,
    },
  };

  const isActive = selectedGrade === gradeCode;

  return (
    <ConditionalWrapRender
      condition={!!highlightedVariant}
      wrapper={HighlightedCard}
      text={highlightedText}
      variant={highlightedVariant}
      spanned
      active={isActive}
    >
      <div
        className={classNames(styles.searchResultCardRoot, {
          [styles.gridLayout]: gridLayout,
          [styles.highlighted]: !!highlightedVariant,
          [styles.active]: isActive && !highlightedVariant,
        })}
        data-test-search-result-card="container"
        data-grade={accommodationDescription || ''}
      >
        {setSelection && (
          <button
            className={styles.selectButton}
            onClick={() => setSelection(selection)}
            type="button"
            data-testid="accommodation-card-button"
          >
            Select {accommodationDescription}
          </button>
        )}
        <div className={styles.inner}>
          {galleryPreview}
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </ConditionalWrapRender>
  );
};
